export default [
  {
    path: '/activity/research',
    name: 'activity_research',
    meta: {
      title: '备孕美肤礼'
    },
    component: () => import('views/activity/research')
  },
  {
    path: '/activity/home_banner_best_guidance',
    name: 'activity_home_banner_best_guidance',
    meta: {
      title: '孕橙快速好孕指南'
    },
    component: () => import('views/activity/home_banner_best_guidance')
  },
  {
    path: '/activity/home_banner_new_user',
    name: 'activity_home_banner_new_user',
    meta: {
      title: '孕橙快速好孕指南'
    },
    component: () => import('views/activity/home_banner_new_user')
  },
  {
    path: '/activity/221111_thermometer',
    name: 'activity_221111_thermometer',
    meta: {
      title: '双十一抢先购'
    },
    component: () => import('views/activity/221111_thermometer')
  },
  {
    path: '/activity/221111_other',
    name: 'activity_221111_other',
    meta: {
      title: '双十一抢先购'
    },
    component: () => import('views/activity/221111_other')
  },
  {
    path: '/activity/221111_pregnancy',
    name: 'activity_221111_pregnancy',
    meta: {
      title: '双十一抢先购'
    },
    component: () => import('views/activity/221111_pregnancy')
  },
  {
    path: '/activity/xiaohongshu_221119',
    name: 'xiaohongshu_221119',
    meta: {
      title: '孕橙CEO的心里话'
    },
    component: () => import('views/activity/xiaohongshu_221119')
  },
  {
    path: '/activity/xiaohongshu_230530',
    name: 'xiaohongshu_230530',
    meta: {
      title: '征集小红书达人'
    },
    component: () => import('views/activity/xiaohongshu_230530')
  },
  {
    path: '/activity/221212_thermometer',
    name: 'activity_221212_thermometer',
    meta: {
      title: '12.12火爆来袭'
    },
    component: () => import('views/activity/221212_thermometer')
  },
  {
    path: '/activity/221212_other',
    name: 'activity_221212_other',
    meta: {
      title: '12.12火爆来袭'
    },
    component: () => import('views/activity/221212_other')
  },
  {
    path: '/activity/221212_pregnancy',
    name: 'activity_221212_pregnancy',
    meta: {
      title: '12.12火爆来袭'
    },
    component: () => import('views/activity/221212_pregnancy')
  },
  {
    path: '/activity/vip_0411',
    name: 'activity_vip_0411',
    meta: {
      title: '周二会员日特惠活动'
    },
    component: () => import('views/activity/vip_0411')
  },
  {
    path: '/activity/vip_0415',
    name: 'activity_vip_0415',
    meta: {
      title: '周二会员日特惠活动'
    },
    component: () => import('views/activity/vip_0415')
  },
  {
    path: '/activity/vip_day_join_group',
    name: 'activity_vip_day_join_group',
    meta: {
      title: '周二会员日优孕师直播'
    },
    component: () => import('views/activity/vip_day_join_group')
  },
  {
    path: '/activity/vip_0418',
    name: 'activity_vip_0418',
    meta: {
      title: '进群享会员日特惠'
    },
    component: () => import('views/activity/vip_0418')
  },
  {
    path: '/activity/act_230618',
    name: 'activity_230618',
    meta: {
      title: '618年中盛典'
    },
    component: () => import('views/activity/act_230618')
  },
  {
    path: '/activity/float_618',
    name: 'float_618',
    meta: {
      title: '进群享618特惠'
    },
    component: () => import('views/activity/float_618')
  },
  {
    path: '/activity/preg_knowledges',
    name: 'preg_knowledges',
    meta: {
      title: ''
    },
    component: () => import('views/activity/preg_knowledges')
  },
  {
    path: '/activity/preg_knowledges_video',
    name: 'preg_knowledges_video',
    meta: {
      title: ''
    },
    component: () => import('views/activity/preg_knowledges_video')
  },
  {
    path: '/activity/preg_101',
    name: 'preg_101',
    meta: {
      title: ''
    },
    component: () => import('views/activity/preg_101')
  },
  {
    path: '/activity/24_618_page',
    name: '24_618_page',
    meta: {
      title: ''
    },
    component: () => import('views/activity/24_618_page')
  },
  {
    path: '/activity/24_618_page_yunqi',
    name: '24_618_page_yunqi',
    meta: {
      title: ''
    },
    component: () => import('views/activity/24_618_page_yunqi')
  }
  ,
  {
    path: '/activity/daily_activity',
    name: 'daily_activity',
    meta: {
      title: '孕橙健康关爱季'
    },
    component: () => import('views/activity/daily_activity')
  },
  {
    path: '/activity/zyq_plan',
    name: 'zyq_plan',
    meta: {
      title: '居家人授好孕无忧计划助你幸“孕”加倍'
    },
    component: () => import('views/activity/zyq_plan')
  },
  {
    path: '/activity/home_activity',
    name: 'home_activity',
    meta: {
      title: '备孕好物'
    },
    component: () => import('views/activity/home_activity')
  },
  {
    path: '/activity/home_knowledges',
    name: 'home_knowledges',
    meta: {
      title: '备孕不是“随缘等”'
    },
    component: () => import('views/activity/home_knowledges')
  }
]